import * as ClientCache from "../../login/ClientCache";
import * as BSEntities from "../../constants/BSEntities";
import * as DomainBaseEntities from "../../constants/DomainBaseEntities";
import {TreeModelProvider} from "./TreeModelProvider";
import * as ObjectChecker from "../../common/NamaCommon";
import * as WithParents from "../../constants/EntitiesWithLedgerEffectsOrWithParents";
import * as CommonFieldIds from "../../constants/CommonFieldIds";
import {HierarchyFilterHelper} from "./HierarchyFilterHelper";
import * as DomainBaseFieldIDs from "../../constants/DomainBaseFieldIDs";

export let GROUP_FILTER_HELPER = new HierarchyFilterHelper("group." + CommonFieldIds.FULL_HIERARCHY_PATH);
let DmsDOCUMENT_FILTER_HELPER = new HierarchyFilterHelper("parent." + CommonFieldIds.FULL_HIERARCHY_PATH);
export let PARENT_FILTER_HELPER = new HierarchyFilterHelper(CommonFieldIds.HIERARCHY_PATH);
let ACCOUNT_CHART_WHEN_DEBIT_FILTER_HELPER = new HierarchyFilterHelper(
    DomainBaseFieldIDs.Account_chartWhenDebit + "." + CommonFieldIds.FULL_HIERARCHY_PATH);
let AU_PROCEDURES_AND_TEST_FILTER_HELPER = new HierarchyFilterHelper(
    DomainBaseFieldIDs.AUTestDef_phase + "." + DomainBaseFieldIDs.AUPhase_fullHierarchyPath);
let REMARK_TYPE_FILTER_HELPER = new HierarchyFilterHelper("remarkType." + CommonFieldIds.FULL_HIERARCHY_PATH);

export class TreeViewForListView {
    constructor(entityType) {
        this.entityType = entityType;
    }

    getHelperForListView() {
        let entityType = this.entityType;
        if (BSEntities.Account === entityType)
            return ACCOUNT_CHART_WHEN_DEBIT_FILTER_HELPER;
        if (BSEntities.Remark === entityType)
            return REMARK_TYPE_FILTER_HELPER;
        if (BSEntities.DetailedRemark === entityType)
            return REMARK_TYPE_FILTER_HELPER;
        if (BSEntities.DMSDocument === entityType)
            return DmsDOCUMENT_FILTER_HELPER;
        if (ObjectChecker.isAnyEqualToFirst(entityType, BSEntities.AUTestDef))
            return AU_PROCEDURES_AND_TEST_FILTER_HELPER;
        if (hasParentEntity(entityType))
            return PARENT_FILTER_HELPER;
        if (ClientCache.isMasterFile(entityType))
            return GROUP_FILTER_HELPER;
        return null;
    }

    getTreeModelProviderForListView() {
        let entityType = this.entityType;
        if (BSEntities.Account === entityType)
            return new TreeModelProvider(BSEntities.AccountsChart);
        if (BSEntities.DMSDocument === entityType)
            return new TreeModelProvider(BSEntities.DMSFolder);
        if (BSEntities.Remark === entityType)
            return new TreeModelProvider(BSEntities.RemarkType);
        if (BSEntities.DetailedRemark === entityType)
            return new TreeModelProvider(BSEntities.RemarkType);
        if (ObjectChecker.isAnyEqualToFirst(entityType, BSEntities.AUTestDef))
            return new TreeModelProvider(BSEntities.AUPhase);
        if (hasParentEntity(entityType))
            return new TreeModelProvider(entityType);
        if (ClientCache.isMasterFile(entityType))
            return new TreeModelProvider(DomainBaseEntities.MasterGroup, entityType);
        return null;
    }

}

export function hasParentEntity(entityType) {
    return WithParents.HAS_PARENT_ENTITIES.contains(entityType);
}